module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/heroMobile@1x.dd0c66c.png";